/* HACK: Reference the actual entry point at /src/client/index.js without ejecting react-scripts */
require("./client/index");
